import {Inject, Injectable} from '@angular/core';
import {CoreService} from '../core/core.service';
import { HttpClient } from '@angular/common/http';
import {HTTP_CLIENT_WITH_ERROR_HANDLING} from '../app.di';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {IConfig} from '../shared/orientationtest-config/i-config';
import {Config} from '../shared/orientationtest-config/config';

@Injectable()
export class ConfigService extends CoreService {
    private static CONFIG_PATH = '/app-api/beroepenpagina/api/config';

    constructor(@Inject(HTTP_CLIENT_WITH_ERROR_HANDLING) private httpWithErrorHandling: HttpClient) {
        super();
    }

    public getConfig(): Observable<Config> {
        return this.httpWithErrorHandling.get<IConfig>(`${ConfigService.CONFIG_PATH}`).pipe(
            map(iConfig => Config.fromInterface(iConfig))
        )
    }
}
